import { render } from "./DynvibeChartMore.vue?vue&type=template&id=82b441e4&scoped=true"
import script from "./DynvibeChartMore.vue?vue&type=script&lang=js"
export * from "./DynvibeChartMore.vue?vue&type=script&lang=js"

import "./DynvibeChartMore.vue?vue&type=style&index=0&id=82b441e4&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82b441e4"]])

export default __exports__